'use client';

import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { CSSProperties, ReactNode } from 'react';

export const ColumnContainer = (props: {
	children: ReactNode;
	withPadding: boolean;
	containerStyle: CSSProperties;
	width?: string;
	height?: string;
	id?: string;
}) => {
	const theme = useTheme();
	const isDownXs = useMediaQuery(theme.breakpoints.down('md'));

	const defaultBackgroundColor = props.containerStyle?.backgroundColor ?? 'white';

	return (
		<Box
			id={props.id}
			height={props.height ?? '100%'}
			width={`${(props.width ?? isDownXs) ? '100%' : '50%'}`}
			sx={{
				flexGrow: 1,
				height: 'auto',
				padding: props.withPadding ? '0 5%' : undefined,
				textAlign: 'center',
				[theme.breakpoints.up('sm')]: {
					height: props.height ?? '100vh',
					textAlign: 'left',
				},
				overflowY: 'auto',
			}}
			style={{ ...props.containerStyle, backgroundColor: defaultBackgroundColor }}
		>
			{props.children}
		</Box>
	);
};
